import { ORGANIZATIONS, USER_ROLES_WITHOUT_GUEST_AND_USER } from 'cpool-constants';
import { z } from 'zod';

import { PAGINATION } from '~/constants';

export const userListSearchSchema = z.object({
    createUser: z.literal(true).optional().catch(undefined),
    /**
     * aggregateId of the user whose edit modal is open. Keeping it in the URL makes the edit form
     * deep-linkable, so an aggregateId shown elsewhere can link straight into it - KC-6459
     */
    editUserId: z.string().uuid().optional().catch(undefined),
    organization: z.array(z.nativeEnum(ORGANIZATIONS)).default([]).catch([]),
    page: z.number().int().positive().optional().default(PAGINATION.DEFAULT_PAGE).catch(PAGINATION.DEFAULT_PAGE),
    pageSize: z
        .number()
        .refine((pageSize) => PAGINATION.USER_LIST.PAGE_SIZE_OPTIONS.includes(pageSize))
        .optional()
        .default(PAGINATION.USER_LIST.DEFAULT_PAGE_SIZE)
        .catch(PAGINATION.USER_LIST.DEFAULT_PAGE_SIZE),
    role: z.array(z.nativeEnum(USER_ROLES_WITHOUT_GUEST_AND_USER)).optional().default([]).catch([]),
    /** Free text matched against first name, last name, e-mail, aggregateId and PID - KC-6459 */
    search: z.string().optional().default('').catch(''),
});

export type UserListSearchSchema = z.infer<typeof userListSearchSchema>;
